module.exports = __webpack_public_path__ + "c04b2182f9b410a12916b296eb7e1c56.gif";